// extracted by mini-css-extract-plugin
module.exports = {"searchTipsWrapper":"_3YGlaImX"};